import React, { useEffect } from 'react'
import routes from './routes'
import { Route, Routes, matchPath, useLocation, useNavigate } from 'react-router-dom'
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { isEmpty } from 'lodash-es'

import { PrivateRoute } from './PrivateRoute'
import { ADMIN_ROLE, APPROVED_STATUS, OWNER_ROLE, SUSPEND_NEW_BOOKING } from 'constants/headerConstant'
import { GOOGLE_RECAPTCHA_KEY } from 'constants/appConstants'

import { getCompanyByEmployId, getCurrentEmploy, getParamFromURL } from 'utils/booking/common'
import paths from './paths'
import { useAppSelector } from 'store/store'

const RouteList = () => {
  const currentCustomer = useAppSelector((state) => state.currentCustomer)
  const enabledEWallet = useAppSelector((state) => state.extraInfos?.enabled_ewallet)
  const showApiDashboard = useAppSelector((state) => state.extraInfos?.show_api_dashboard)
  const enableCaptchaVerification = useAppSelector((state) => state.extraInfos?.enable_captcha_verification)
  const accountModal = useAppSelector((s) => s.accountModal)

  let currentEmploy: any = {}
  let company: any = {}
  if (!isEmpty(currentCustomer?.employs) && currentCustomer?.currentCompanyId) {
    currentEmploy = getCurrentEmploy(currentCustomer?.employs, currentCustomer?.currentCompanyId)
    company = getCompanyByEmployId(currentCustomer?.companies, currentEmploy?.company_id)
  } else {
    currentEmploy = { ...currentCustomer }
  }
  const routeList = Object.keys(routes).map((key) => routes[key])
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const bpWallet = currentCustomer?.currentCompanyId && enabledEWallet?.includes('business')
  const nonBpWallet = !currentCustomer?.currentCompanyId && enabledEWallet?.includes('individual')
  const assignedRole = currentEmploy.assigned_role || ''
  const isShowEmployee =
    currentCustomer?.currentCompanyId && (assignedRole === OWNER_ROLE || assignedRole === ADMIN_ROLE)
  let isShowDashboard = showApiDashboard
  if (currentCustomer?.currentCompanyId && !isEmpty(company)) {
    const { status, show_api_dashboard: showApiDashboard } = company
    isShowDashboard = (status === APPROVED_STATUS || status === SUSPEND_NEW_BOOKING) && showApiDashboard
  }
  const isExportAutomatic = getParamFromURL('is_export_automatic')
  const routeListRender = routeList.filter((i) => {
    const { path } = i
    const pattern = path || ''

    if (!nonBpWallet && matchPath(pattern, paths.WALLET)) {
      return false
    }
    if (!bpWallet && matchPath(pattern, paths.WALLET_BUSINESS)) {
      return false
    }
    if (!isShowDashboard && matchPath(pattern, paths.API_DASHBOARD)) {
      return false
    }
    if (!isShowDashboard && matchPath(pattern, paths.TEST_MY_BOOKING)) {
      return false
    }
    if (!isShowEmployee && matchPath(pattern, paths.EMPLOYEES)) {
      return false
    }
    if (currentCustomer.id && !accountModal.modalType && matchPath(pattern, paths.SIGN_IN)) {
      return false
    }
    if (currentCustomer.id && !accountModal.modalType && matchPath(pattern, paths.SIGN_UP)) {
      return false
    }
    return true
  })
  const pathNotInList = !routeListRender.some((route) => {
    return matchPath(route.path || '', pathname)
  })

  useEffect(() => {
    if (pathNotInList) navigate('/')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathNotInList])

  const renderRoutes = () => (
    <Routes>
      {routeListRender.map((route) => {
       const isPrivate = !isExportAutomatic && matchPath(route.path || '', paths.ANALYTICS)
        return (
          <Route
            key={route.path}
            path={route.path}
            caseSensitive={route.caseSensitive}
            element={(route.isPrivate ||isPrivate) ? <PrivateRoute component={route.element} /> : route.element}
          />
        )
      })}
    </Routes>
  )
  if (enableCaptchaVerification) {
    return (
      <GoogleReCaptchaProvider reCaptchaKey={GOOGLE_RECAPTCHA_KEY} scriptProps={{ async: true, defer: true }}>
        {renderRoutes()}
      </GoogleReCaptchaProvider>
    )
  }

  return renderRoutes()
}

export default RouteList
